import Papa from "papaparse";
import _ from "lodash";
import { getCreateRouteManifestRequests } from "../util/CreateRouteManifestGenerator";

export const parseRouteManifestCSV = (orderFile, clientId) => {
  let createRouteManifestRequests = [];
  let skipEmptyLineStartIndex = null;
  let rowIndex = -1;

  return new Promise((resolve, reject) => {
    Papa.parse(orderFile, {
      header: true,
      skipEmptyLines: true,
      transformHeader: (header) => {
        return header.trim();
      },
      error: () => {
        return reject({ errors: ["File Processing Failed!"] });
      },
      step: ({ data, meta }) => {
        rowIndex = rowIndex + 1;

        // Validate columns
        if (createRouteManifestRequests.length === 0) {
          const columnErrors = [];

          // TODO: Add more validations here
          [].forEach((field) => {
            if (meta?.fields.indexOf(field) < 0)
              columnErrors.push(`Column ${field} is missing`);
          });
          if (columnErrors.length > 0) return reject({ errors: columnErrors });
        }

        //Mapping rows to order requests
        const createOrderRequest = getCreateRouteManifestRequests(
          data,
          clientId
        );

        //removing row object keys with empty values
        const newRowData = _.omitBy(
          createOrderRequest,
          (value) => value === null
        );

        //counting the start of the empty line index
        if (Object.keys(newRowData).length === 0) {
          if (!skipEmptyLineStartIndex) skipEmptyLineStartIndex = rowIndex;
        } else skipEmptyLineStartIndex = null;

        createRouteManifestRequests.push(newRowData);
      },
      complete: () => {
        //removing the empty rows at the end
        if (skipEmptyLineStartIndex) {
          createRouteManifestRequests = createRouteManifestRequests.splice(
            0,
            skipEmptyLineStartIndex
          );
        }

        let uniqueOrders = createRouteManifestRequests.filter(
          (order, index, self) =>
            index === self.findIndex((t) => t.id === order.id)
        );

        return resolve({
          data: {
            createRouteManifestRequests: uniqueOrders,
          },
        });
      },
    });
  });
};
